// extracted by mini-css-extract-plugin
module.exports = {"errorText":"GeneralError_errorText__IoemA"};